import { useQueryClient } from "react-query";
import { ExistingPaymentMethod } from "../types";
import { FETCH_EXISTING_PAYMENT_METHOD } from "../services";
import { COUNTRY_CODE_REGEX } from "../constants";

export function useExistingMethodCountryCode() {
  const queryClient = useQueryClient();
  const existingPayMethod = queryClient.getQueryData<ExistingPaymentMethod>(
    FETCH_EXISTING_PAYMENT_METHOD
  );

  return existingPayMethod?.address?.match(COUNTRY_CODE_REGEX)?.[0];
}
